import request from '../../../shared/request'

// new ones
export function fetchAgreements(params) {
  const qs = params.folderId ? `?folderId=${params.folderId}` : ''
  return request(`/job/agreement/${params.jobId}/${qs}`)
}

export function getJobAgreement(job_id) {
  return request(`/job/agreement/${job_id}/`)
}

export function getJobAgreementActivities(follow_up_id) {
  return request(`/job/activities/follow_up/${follow_up_id}/`)
}

export function createJobAgreement(payload) {
  return request(`/job/agreement`, {
    method: 'POST',
    body: payload.formData,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function updateJobAgreement(payload) {
  return request(`/job/agreement/${payload.agreementId}`, {
    method: 'PUT',
    body: payload.formData,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteJobAgreement(payload) {
  return request(`/job/agreement/${payload.agreementId}/`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function uploadAttachments(payload) {
  return request(`/job/agreement/attachment/add`, {
    method: 'POST',
    body: payload.formData,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function createFolder(payload) {
  return request(`/job/agreement/${payload.jobId}/folder`, {
    method: 'POST',
    body: payload,
    headers: {
      Accept: 'application/json'
    }
  })
}

export function updateFolder(payload) {
  return request(`/job/agreement/${payload.folderId}/folder`, {
    method: 'PUT',
    body: payload,
    headers: {
      Accept: 'application/json'
    }
  })
}

export function deleteFolder(payload) {
  return request(`/job/agreement/${payload.folderId}/folder`, {
    method: 'DELETE',
    headers: {
      Accept: 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/job/agreement.js